import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import QuotationPreview from './pages/QuotationPreview';
import Login from './pages/Login';
import Items from './pages/Items';
import Executives from './pages/Executives';
import QuoteBuilder from './pages/QuoteBuilder';
import QuotationDetails from './pages/QuotationDetails';
import api from './services/api';

const App = () => {
    // Bypass login by setting a mock admin user by default
    const [user, setUser] = useState({ id: 1, role: 'Admin', name: 'Mock Admin (Offline Mode)' });
    const [loading, setLoading] = useState(false);

    if (loading) return <div>Loading...</div>;

    return (
        <Router>
            <Routes>
                <Route path="/login" element={!user ? <Login onLogin={setUser} /> : <Navigate to="/dashboard" />} />
                <Route path="/*" element={
                    user ? (
                        <Layout>
                            <Routes>
                                <Route path="/dashboard" element={<QuotationPreview />} />
                                <Route path="/builder" element={<QuoteBuilder />} />
                                <Route path="/quotes/:id" element={<QuotationDetails />} />
                                <Route path="/items" element={<Items />} />
                                <Route path="/executives" element={<Executives />} />
                                <Route path="*" element={<Navigate to="/builder" />} />
                            </Routes>
                        </Layout>
                    ) : (
                        <Navigate to="/login" />
                    )
                } />
            </Routes>
        </Router>
    );
};

export default App;
